module.exports = __webpack_public_path__ + "static/bg_desktop-8b23b183dad6b7203368a8878432a06f.mp4";